/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:6d8700c8-6e61-43d7-b8ef-d95ea0511fb1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_W2eQnDqig",
    "aws_user_pools_web_client_id": "5fdksdn6f96seh9ujgpecs3k3j",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "GTFS_CONTRACTS-prd",
            "region": "eu-west-1"
        },
        {
            "tableName": "GTFS_EMPRESA-prd",
            "region": "eu-west-1"
        },
        {
            "tableName": "GTFS_EXECUTION_MACHINE-prd",
            "region": "eu-west-1"
        },
        {
            "tableName": "GTFS_FUSION-prd",
            "region": "eu-west-1"
        },
        {
            "tableName": "GTFS_LINES-prd",
            "region": "eu-west-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "gtfsRestApi",
            "endpoint": "https://6llri105n0.execute-api.eu-west-1.amazonaws.com/prd",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
